<!-- eslint-disable -->
<template>
  <CommonPages id="about" classs="about-page" titlePrefix="About Us - Buzzronic"
    metaDescription="A trusted ad marketplace designed to boost reach and revenue. Simplify ad trading with secure technology and high-quality inventory worldwide.">

    <div class="story-section">
      <div class="story-section__content">
        <h2 class="story-section__title">Our Story</h2>
        <h3 class="story-section__heading">We believe in the power of performance-driven
          advertising.</h3>
      </div>
      <div class="story-swich-content">
        <div class="story-section__left">
          <img src="@/assets/story-1.png" alt="Our Story Image 1"
            class="story-section__image--main">
        </div>
        <div class="story-section__right">
          <div class="story-section__right-images">
            <img src="@/assets/story-2.png" alt="Our Story Image 2"
              class="story-section__image--top">
            <img src="@/assets/story-3.png" alt="Our Story Image 3"
              class="story-section__image--bottom">
          </div>
          <div class="story-section__content">
            <p class="story-section__text">
              Founded by a team of digital marketing veterans, we’ve grown from a small startup into
              a
              trusted global network. What sets us apart is our hands-on expertise, cutting-edge
              technology, and commitment to fair partnerships. Whether you’re an advertiser looking
              for
              high-converting traffic or a publisher seeking premium offers, we’re here to make your
              journey seamless and profitable.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="stats-section">
      <div class="stat">
        <p class="stat__number">50+</p>
        <p class="stat__description">Countries Served – Running high-performance campaigns across
          North America, Europe.</p>
      </div>
      <div class="stat">
        <p class="stat__number">95%</p>
        <p class="stat__description">Client Retention Rate – Proof of our focus on long-term
          partnerships over quick wins.</p>
      </div>
      <div class="stat">
        <p class="stat__number">1,000+</p>
        <p class="stat__description">Direct Advertisers - Trusted by agencies worldwide to deliver
          performance-driven campaigns.</p>
      </div>
    </div>

    <div class="team-section">
      <div class="team-member-card">
        <img src="@/assets/team-member-1.png" alt="Alex Carter" class="team-member-card__avatar">
        <p class="team-member-card__quote">"Passionate about building meaningful connections between
          brands and audiences, Alex ensures every campaign delivers measurable impact."</p>
        <h4 class="team-member-card__name">Alex Carter</h4>
        <p class="team-member-card__title">Marketing Director</p>
      </div>
      <div class="team-member-card">
        <img src="@/assets/team-member-2.png" alt="Mia Johnson" class="team-member-card__avatar">
        <p class="team-member-card__quote">"With a keen eye for data and trends, Mia turns complex
          numbers into strategies that drive growth and success for our partners."</p>
        <h4 class="team-member-card__name">Mia Johnson</h4>
        <p class="team-member-card__title">Head of Analytics</p>
      </div>
    </div>

  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue';
import '@/css/about.scss';

export default {
  name: 'About',
  components: {
    CommonPages,
  },
};
</script>
